'use client';

import styled, { WebTarget } from 'styled-components';
import Link from 'next/link';
import {
  Box,
  BreakpointMd,
  BreakpointSm,
  Button,
  ColorFoam500,
  ColorTextPrimary,
  ColorTextSecondary,
  Flex,
  FontSize50,
  LineHeight400,
  Spacing12,
  Spacing24,
  TypographyCommonSubBody,
} from '@nyshex/keel';
import Image from 'next/image';

export const NyshexMask = styled(Box)`
  position: absolute;
  top: 70px;
  width: 35vw;
  height: 77vh;
  left: -30px;
  background-position: right top;
  background-size: cover;
  background-repeat: no-repeat;
  background-image: url(/images/Nyshex/nyshex_market_mask.png);
`;

export const LoginContainer = styled(Flex)`
  width: 100vw;
  height: 100vh;
  min-height: 780px;
  background-size: cover;
  background-repeat: no-repeat;
  background-image: url(/images/Nyshex/LoginBackground.svg);

  @media (max-width: ${BreakpointSm}) {
    min-height: 691px;
    height: auto;
  }
`;

export const NyshexLogoImgGrey = styled(Box)`
  width: 50%;
  min-height: 100vh;
  background-size: 135%;
  background-position: 100% 24%;
  background-repeat: no-repeat;
  background-image: url(/images/Nyshex/nyshex_mark_gray.svg);
  position: relative;

  @media (max-width: ${BreakpointMd}) {
    display: none;
  }
`;

export const LoginRightPanel = styled(Flex)`
  width: 50%;
  align-items: center;
  flex-direction: column;

  @media (max-width: ${BreakpointSm}) {
    justify-content: center;
  }

  @media (max-width: ${BreakpointMd}) {
    width: 100%;
    height: fit-content;
  }
`;

export const LoginButton = styled(Button)`
  margin-top: 22px;
`;

export const LoginLink = styled(Link as WebTarget)`
  ${TypographyCommonSubBody};
`;

export const RequestDemoLink = styled(Flex)`
  ${TypographyCommonSubBody};
  align-self: center;
  padding-top: 54px;
  flex-direction: column;
  gap: ${Spacing12};
  a {
    color: ${ColorTextPrimary} !important;
  }
`;

export const NeedHelpLink = styled(LoginLink)`
  align-self: flex-end;
  margin: ${Spacing24};
`;

export const TermsText = styled(Box)`
  color: #a6a9b0;
  font-size: ${FontSize50};
  line-height: ${LineHeight400};
  padding: ${Spacing24};
  position: absolute;
  bottom: 0;
  left: 0;

  @media (max-width: ${BreakpointSm}) {
    position: static;
  }

  a {
    text-decoration: underline;
    color: #a6a9b0;

    &:hover {
      color: ${ColorFoam500};
    }
  }
`;

export const TakeCommandText = styled(Image as WebTarget)`
  position: absolute;
  top: calc(40% - 75px);
  left: 52%;
  width: calc(100vw - 70vw);
`;

export const LoginFormContainer = styled(Flex)`
  flex-direction: column;
  align-items: stretch;
  width: 300px;
  margin-top: 6vh;

  @media (max-width: ${BreakpointMd}) {
    margin-top: 0;
  }

  @media (max-height: 850px) {
    margin-top: 0;
  }

  a {
    color: ${ColorTextSecondary};
  }
`;
